export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5014';
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || '';
export const TOKEN_KEY = 'cli_token';

// Base do endpoint publico /publico/{orcamento,cotacao}/:id.pdf — servido pelo
// sistema-suc. Em prod fica vazio (string) e usa caminho relativo: o nginx do
// portal-cliente faz proxy de /publico/* para o backend interno do sistema-suc,
// fazendo com que tudo viva no mesmo origem (sem CORS, sem mixed content).
// Em dev pode apontar direto pro backend do sistema-suc (ex.: https://backend.centrao.net).
export const PUBLICO_BASE_URL = process.env.REACT_APP_PUBLICO_BASE_URL || '';
